document.addEventListener('click', function () {
  const modal = document.querySelector('.product-media-modal, .media-modal, dialog[open]');
  if (!modal) return;

  modal.addEventListener(
    'wheel',
    function (e) {
      e.stopPropagation();
    },
    { passive: true }
  );

  modal.addEventListener(
    'touchmove',
    function (e) {
      e.stopPropagation();
    },
    { passive: true }
  );
});
